import { all, call } from 'redux-saga/effects';

import watchAuth from './auth/sagas';
import watchDeepLink from './deepLink/sagas';
import watchHandleErrorAction from './errors/sagas';
import exercisesGuides from './exercises/sagas';
import watchFeatures from './features/sagas';
import watchGuides from './guides/sagas';
import watchNavigation from './navigation/sagas';
import watchNotifications from './notifications/sagas';
import watchNutrition from './nutrition/sagas';
import watchPayment from './payment/sagas';
import watchSubscriptions from './subscriptions/sagas';
import watchUser from './user/sagas';
import workoutsGuides from './workouts/sagas';

export default function* rootSaga() {
    yield all([
        call(watchUser),
        call(watchDeepLink),
        call(watchAuth),
        call(watchNotifications),
        call(watchSubscriptions),
        call(watchGuides),
        call(exercisesGuides),
        call(workoutsGuides),
        call(watchNavigation),
        call(watchHandleErrorAction),
        call(watchPayment),
        call(watchNutrition),
        call(watchFeatures),
    ]);
}
